import { computed, Signal } from '@angular/core';
import { Character } from 'src/app/features/characters/types/character';
import { Chat } from 'src/app/features/stories/types/Chat';

export function injectQuotables(
  chatData: Signal<Chat | undefined>,
  characters: Signal<Character[] | undefined>
) {
  return computed<
    {
      id: string;
      displayName: string;
      type: 'user' | 'char';
    }[]
  >(
    () =>
      [
        ...(chatData()?.users.map((u) => ({
          id: u.user.id,
          type: 'user' as const,
          displayName: u.user.displayName,
        })) ?? []),
        ...(characters()?.map((c) => ({
          id: c.id,
          type: 'char' as const,
          displayName: c.name,
        })) ?? []),
      ] as any as {
        id: string;
        displayName: string;
        type: 'user' | 'char';
      }[]
  );
}
